import React, { useState,useEffect } from "react";
import { Container,Row,Col,ButtonGroup,DropdownButton, Button,Dropdown } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import { Loading } from "./Loading";
import ServiceCalls from "../utils/serviceCalls.js";
import Popup from 'reactjs-popup';
import { VendorSetIDDropdown } from '../components/VendorSetIDDropdown';
import * as XLSX from "@e965/xlsx/xlsx.mjs";
import CommonUtils from "../utils/siteUtils";
import { TableRoleDisplay } from '../components/TableRoleDisplay';
import { BarChart, LineChart,AreaChart, Bar, Line, Area,XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';

import "../styles/Admin.css";
const MergeAdminSuppliers = (data) => {
	var supData = [];
	if (data && data.suppliers) {

		var adminSupplier = data.suppliers.filter(s => s.vendorId === '00INACTIVE');
		adminSupplier = (adminSupplier.length > 0) ? adminSupplier[0] : null;
	
		data.suppliers.forEach(function (item, idx) {
			if (adminSupplier) {
				if (item.supplierId !== adminSupplier.supplierId) {
					adminSupplier.contactRoles.forEach(function (roleItem, idx) {
						if (item.contactRoles.findIndex((extItem) => extItem.roleId === roleItem.roleId) === -1) {
							item.contactRoles.push(roleItem);
						}
					});
					supData.push(item);
				}
			}
			else {
				supData.push(item);
			}
		});
		
	}
	return supData;
}

export const AdminDashboards= () => {
	
	return (
		<Container>
			<Row>
				<Col sm={6} className="flex-column borderCurve">
					<PerMonthUsage />
				</Col>
				<Col sm={6} className="flex-column borderCurve">
					<PerYearUsage />
				</Col>
			</Row>
			<Row>
				<Col sm={12} className="flex-column borderCurve">
					<PerMonthAudits />					
				</Col>	
			</Row>
		</Container>
	);
};

export const PerMonthUsage = (props) => {
	const [isLoading, setIsLoading] = useState(true);
	const [currentIndex, setCurrentIndex] = useState(-1);
	const [chartData, setChartData] = useState(null);
	const [showPopUp, setShowPopUp] = useState(false);
	const [currentAudience, setCurrentAudience] = useState("GLOBAL");
	const [isAudiencesReady, setIsAudiencesReady] = useState(false);
	useEffect(() => {
		if (isAudiencesReady) {
			getData(currentAudience);
		}
	}, [isAudiencesReady]);

	const getData = async (audience) => {		
		ServiceCalls.getSiteUsage(6, audience).then(function (data) {
			if (data) {
				setChartData(data);
				setIsLoading(false);
			}
		});
	}
	const prepData = (_data, index) => {
		setCurrentIndex(_data.activeTooltipIndex);
		setShowPopUp(true);
	}
	const closePopUp = () => {
		setShowPopUp(false);
	}
	const showMonthData = () => {
		var curMonth = chartData[currentIndex];
		var columns = [
			{
				name: 'Name',
				cell: row => {
					return `${(row.firstName) ? row.firstName : ""} ${(row.lastName) ? row.lastName:""}`
				},
				maxwidth: "200px",
			},
			{
				name: 'Email',
				selector: row => row.email,
				maxwidth: "200px",
			},
			{
				name: 'Invited Date',
				cell: row => {
					return (row.ohcidRegistration.invite_Dt && row.ohcidRegistration.invite_Dt)
						? CommonUtils.formatDate(row.ohcidRegistration.invite_Dt)
						:''
				},
				maxwidth: "150px",
			},
			{
				name: 'Registration Status',
				cell: row => {
					return (row.ohcidRegistration)
						? CommonUtils.determineRegistrationStatus(row.ohcidRegistration.statusId)
						:''
				},
				maxwidth: "150px",
			},
			{
				name: 'Last SignOn Date',
				cell: row => {
					return (row.lastSignOnDate)
						? CommonUtils.formatDate(row.lastSignOnDate)
						: ''
				},
				maxwidth: "150px",
			},
			{
				name: 'Suppliers',
				cell: row => {
		
					var supData = MergeAdminSuppliers(row);
					
					return (
						// Supplier Details
						<Container className="dbSupplierArea">
							{supData.map(function (sup, sIdx) {							
								var userRoles = sup.contactRoles;								
								return (
									 <Row key={sIdx} >
										<Col sm={12} className="dbSupplierTitle">{sup.supplierName} ({sup.vendorSetId} {sup.vendorId})</Col>
										{
											<TableRoleDisplay roles={userRoles} showInactiveRoles={true} />
										}
									</Row>
								)
							})}
						</Container>
					)
				},
			}
		];
		const customStyles = {
			// search results DataTable custom styles
			table: {
				style: {
					// table styles
					margin: '0',
					height: '800'
				},
			},
			headCells: {
				style: {
					// header styles
					fontSize: '12px',
					justifyContent: 'left !important',
					color: 'white',
					paddingLeft: '1%',
					borderRight: '1px solid white',
					fontWeight: '400',

				},
			},
			head: {
				style: {
					// head styles - so calendars go over
					zIndex: '99'
				},
			},
			headRow: {
				style: {
					// header styles
					backgroundColor: '#003C71',
				},
			},
		};
	
		return (
			<div className="dbPopup">
			<Container fluid>
					<Row>
						<Col sm={3}>
							<Button className="dashboard-popup-buttons" onClick={() => closePopUp()} >
								Close
							</Button>
						</Col>
					<Col sm={{ size: 3, offSet: 6 }}>
						<ButtonGroup className="exportButtonGrp" style={{ float: "right" }}>
							<DropdownButton
								title="Export Results"
								id="bg-nested-dropdown">
									<Dropdown.Item eventKey="1" onClick={() => exportCSVResults()}>CSV</Dropdown.Item>
									<Dropdown.Item eventKey="2" onClick={() => exportExcelResults()}>Excel</Dropdown.Item>
							</DropdownButton>
						</ButtonGroup>
					</Col>
				</Row>
				<Row>
					<DataTable
						columns={columns}
							data={curMonth.contacts} 
							keyField="contactId"
							fixedHeader
							fixedHeaderScrollHeight="800px"	
							striped
							responsive     
							customStyles={customStyles} 
					/>
				</Row>
				</Container>
			</div>
		)
	}
	const prepForExport = () => {
		var curMonth = chartData[currentIndex];
		var results = [];
		curMonth.contacts.forEach((row) => {
			var rowObj = {
				"First Name":row.firstName,
				"Last Name": row.lastName,
				"Email": row.email,
				"Invited Date": (row.ohcidRegistration && row.ohcidRegistration.invite_Dt)
					? CommonUtils.formatDate(row.ohcidRegistration.invite_Dt)
					: '',
				"Registration Status": (row.ohcidRegistration)
					? CommonUtils.determineRegistrationStatus(row.ohcidRegistration.statusId)
					: '',
				"Last SignOn Date": (row.lastSignOnDate)
					? CommonUtils.formatDate(row.lastSignOnDate)
					: '',
				"Supplier": "",
				"Supplier Set ID": "",
				"Supplier ID": "",				
				"Role": "",
				"Role Enabled": "",
			};
				//Get Suppliers for Row
				row.suppliers.forEach((sup) => {
					var supObj = Object.assign({}, rowObj);
					supObj["Supplier"] = sup.supplierName;
					supObj["Supplier Set ID"] = sup.vendorSetId;
					supObj["Supplier ID"] = sup.vendorId;
					sup.contactRoles.map((role) =>{
						var roleObj = Object.assign({}, supObj);
						roleObj["Role"] = role.displayName.split(',')[0];
						roleObj["Role Enabled"] = role.enabled;

						results.push(roleObj);
						return roleObj;
					});
					
				});
			}		
		);
		return results;	
	}

	const exportExcelResults = () => {
		const ws = XLSX.utils.json_to_sheet(prepForExport());
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Monthly Usage");
		XLSX.writeFile(wb, "PSSP_MonthlyLogs.xlsx");
	};

	const exportCSVResults = () => {
		const ws = XLSX.utils.json_to_sheet(prepForExport());
		const csv = XLSX.utils.sheet_to_csv(ws);
		const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
		const url = URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		link.download = "PSSP_MonthlyLogs.csv";
		link.click();
	};

	const updateAudience = (audience) => {
		setIsLoading(true);
		getData(audience);
		setCurrentAudience(audience);
	}
	const onAudienceReady = (ready) => {
		setIsAudiencesReady(ready);
	}
	return (
		(isLoading)
			? <Container className="accessSearchArea flex-column borderCurve">
				<Row className="accessSearchHeader">
					<Col sm={6} className="dashboardTitle">
						<h3>Monthly Usage</h3>
					</Col>
					<Col sm={6}>
						<VendorSetIDDropdown onChange={updateAudience} colSize={5} onListLoaded={onAudienceReady} currentAudience={currentAudience} showGlobalOption={true} />
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						<Loading />
					</Col>				
				</Row>
			</Container>
			:
			<Container className="accessSearchArea flex-column borderCurve">
		
					<Row className="accessSearchHeader">
					<Col sm={6} className="dashboardTitle">
							<h3>Monthly Usage</h3>
						</Col>
						<Col sm={6}>
						<VendorSetIDDropdown onChange={updateAudience} colSize={5} onListLoaded={onAudienceReady} currentAudience={currentAudience} showGlobalOption={true} />
						</Col>
					</Row>
				<Row>
					<Col sm={12}>
					<BarChart style
							width={500}
							height={300}
						onClick={prepData}
						data={chartData}
						margin={{
							top: 20,
							right: 30,
							left: 20,
							bottom: 5,
						}}
					>
						<CartesianGrid strokeDasharray="9 9" />
						<XAxis dataKey="title" />
						<YAxis />
						<Tooltip />
						<Legend verticalAlign="top" layout="horizontal" align="left" height={36} />							
							<Bar dataKey="number_Active" name="Active" stackId="a" fill="#002677" />
							<Bar dataKey="number_Invited" name="Invited" stackId="a" fill="#F5B700" />
							<Bar dataKey="number_Not_Responded" name="Not Responded" stackId="a" fill="#FF612B" />
							<Bar dataKey="number_Registered" name="Registered" stackId="a" fill="#0066F5" />
							<Bar dataKey="number_Shared" name="Shared" stackId="a" fill="#4B4D4F" />
						</BarChart>
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						{(currentIndex > -1) ?
							<Popup open={showPopUp} modal closeOnDocumentClick={true} closeOnEscape={true} onClose={closePopUp}>
								{(close) => (
									showMonthData()
								)}
							</Popup>

							: <></>}
					</Col>
				</Row>
		</Container>
	);
}

export const PerYearUsage = (props) => {
	const [isLoading, setIsLoading] = useState(true);
	const [chartData, setChartData] = useState(null);
	const [currentAudience, setCurrentAudience] = useState("GLOBAL");
	const [isAudiencesReady, setIsAudiencesReady] = useState(false);
	useEffect(() => {
		if (isAudiencesReady) {
			getData(currentAudience);
		}
	}, [isAudiencesReady]);

	const getData = async (audience) => {
		//currentAudience
		ServiceCalls.getSiteUsagePerYear(audience).then(function (data) {
			if (data) {
				setChartData(data);
				setIsLoading(false);
			}
		});
	}
	const updateAudience = (audience) => {
		setIsLoading(true);
		setCurrentAudience(audience);
		getData(audience);
	}
	const onAudienceReady = (ready) => {
		setIsAudiencesReady(ready);
	}

		return (
			(isLoading)
				? <Container className="accessSearchArea flex-column borderCurve">
					<Row className="accessSearchHeader">
						<Col sm={6} className="dashboardTitle">
							<h3>Yearly Adoption</h3>
						</Col>
						<Col sm={6}>
							<VendorSetIDDropdown onChange={updateAudience} colSize={5} onListLoaded={onAudienceReady} currentAudience={currentAudience} showGlobalOption={true} />
						</Col>
					</Row>
					<Row>
						<Col sm={12}>
							<Loading />
						</Col>
					</Row>
				</Container>
				:
				<Container className="accessSearchArea flex-column borderCurve">
					<Row className="accessSearchHeader">
						<Col sm={6} className="dashboardTitle">
							<h3>Yearly Adoption</h3>
						</Col>
						<Col sm={6}>
							<VendorSetIDDropdown onChange={updateAudience} colSize={5} onListLoaded={onAudienceReady} currentAudience={currentAudience} showGlobalOption={true} />
						</Col>
					</Row>
					<Row>
						<Col sm={12}>
							<LineChart
								width={500}
								height={300}
								data={chartData}
								margin={{
									top: 5,
									right: 30,
									left: 20,
									bottom: 5,
								}}
							>
								<CartesianGrid strokeDasharray="9 9" />
								<XAxis dataKey="title" />
								<YAxis />
								<Tooltip />
								<Legend verticalAlign="top" layout="horizontal" align="left" height={36} />
								<Line type="monotone" dataKey="number_Active" name="Active" stroke="#002677" />
								<Line type="monotone" dataKey="number_Invited" name="Invited" stroke="#F5B700" activeDot={{ r: 8 }} />
								<Line type="monotone" dataKey="number_Not_Responded" name="Not Responded" stroke="#FF612B" />

							</LineChart>
						</Col>
					</Row>
				</Container>
		);
	}

export const PerMonthAudits = (props) => {
		const [isLoading, setIsLoading] = useState(true);
		const [showPopUp, setShowPopUp] = useState(false);
		const [chartData, setChartData] = useState(null);
		const [currentIndex, setCurrentIndex] = useState(-1);
		const [currentAudience, setCurrentAudience] = useState("GLOBAL");
		const [isAudiencesReady, setIsAudiencesReady] = useState(false);
		useEffect(() => {
			if (isAudiencesReady) {
				getData(currentAudience);
			}
		}, [isAudiencesReady]);

		const getData = async (audience) => {
			//currentAudience
			ServiceCalls.getSiteAudits(12, audience).then(function (data) {
				if (data) {
					setChartData(data);
					setIsLoading(false);
				}
			});
		}
		const prepData = (_data, index) => {
			setCurrentIndex(_data.activeTooltipIndex);
			setShowPopUp(true);
		}
		const closePopUp = () => {
			setShowPopUp(false);
		}
		const showAuditData = () => {
			var curMonth = chartData[currentIndex];
			var columns = [
				{
					name: 'Audit Id',
					selector: row => row.auditId,
					width: "100px"
				},
				{
					name: 'Create Date',
					cell: row => {
						return (row.createDt)
							? CommonUtils.formatDate(row.createDt)
							: ''
					},
					width: "100px"
				},
				{
					name: 'Contact Name',
					cell: row => {
						return `${(row.contact.firstName) ? row.contact.firstName : ""} ${(row.contact.lastName) ? row.contact.lastName : ""}`
					},
					width: "200px"
				},
				{
					name: 'Contact Email',
					cell: row => {
						return (row.contact.email) ? row.contact.email : ""
					},
					width: "200px"
				},
				{
					name: 'Audit Type',
					selector: row => row.auditType.description,
					width: "225px"
				},
				{
					name: 'Message',
					cell: row => {
						return (row.message.length > 250) ? row.message.substring(0, 247) + "..." : row.message
					}
				}
			];
			const customStyles = {
				// search results DataTable custom styles
				table: {
					style: {
						//Table styles
						margin: '0',
						height: '800'
					},
				},
				headCells: {
					style: {
						// header styles
						fontSize: '12px',
						justifyContent: 'left !important',
						color: 'white',
						paddingLeft: '1%',
						borderRight: '1px solid white',
						fontWeight: '400',

					},
				},
				head: {
					style: {
						// head styles - so calendars go over
						zIndex: '99'
					},
				},
				headRow: {
					style: {
						// header styles
						backgroundColor: '#003C71',
					},
				},
			};

			return (
				<div className="dbPopup">
					<Container fluid>
						<Row>
							<Col sm={3}>
								<Button className="dashboard-popup-buttons" onClick={() => closePopUp()}>
									Close
								</Button>
							</Col>
							<Col sm={{ size: 3, offSet: 6 }}>
								<ButtonGroup className="exportButtonGrp" style={{ float: "right" }}>
									<DropdownButton
										title="Export Results"
										id="bg-nested-dropdown">
										<Dropdown.Item eventKey="1" onClick={() => exportCSVResults()}>CSV</Dropdown.Item>
										<Dropdown.Item eventKey="2" onClick={() => exportExcelResults()}>Excel</Dropdown.Item>
									</DropdownButton>
								</ButtonGroup>
							</Col>
						</Row>
						<Row>
							<DataTable
								columns={columns}
								data={curMonth.audits}
								keyField="auditId"
								fixedHeader								
								striped
								responsive
								fixedHeaderScrollHeight="800px"
								customStyles={customStyles}
							/>
						</Row>
					</Container>
				</div>
			)
		}
		const prepForExport = () => {
			var curMonth = chartData[currentIndex];
			var results = [];
			curMonth.audits.forEach((row) => {
				var rowObj = {
					"AuditId": row.auditId,
					"Create Date": (row.createDt)
						? CommonUtils.formatDate(row.createDt)
						: '',
					"Contact Name": `${(row.contact.firstName) ? row.contact.firstName : ""} ${(row.contact.lastName) ? row.contact.lastName : ""}`,
					"Contact Email": (row.contact.email) ? row.contact.email : "",
					"Audit Type": row.auditType.description,
					"Message": row.message,
				};
				results.push(rowObj);
			});
			return results;
		}

		const exportExcelResults = () => {
			const ws = XLSX.utils.json_to_sheet(prepForExport());
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "Monthly Usage");
			XLSX.writeFile(wb, "PSSP_MonthlyActions.xlsx");
		};

		const exportCSVResults = () => {
			const ws = XLSX.utils.json_to_sheet(prepForExport());
			const csv = XLSX.utils.sheet_to_csv(ws);
			const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
			const url = URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.download = "PSSP_MonthlyActions.csv";
			link.click();
		};
		const updateAudience = (audience) => {
			setIsLoading(true);
			getData(audience);
			setCurrentAudience(audience);
		}
		const onAudienceReady = (ready) => {
			setIsAudiencesReady(ready);
		}
		return (
			(isLoading)
				? <Container className="accessSearchArea flex-column borderCurve">
					<Row className="accessSearchHeader">
						<Col sm={6} className="dashboardTitle">
							<h3>Monthly Actions</h3>
						</Col>
						<Col sm={6}>
							<VendorSetIDDropdown onChange={updateAudience} colSize={5} onListLoaded={onAudienceReady} currentAudience={currentAudience} showGlobalOption={true} showAdminOption={true} />
						</Col>
					</Row>
					<Row>
						<Col sm={12}>
							<Loading />
						</Col>
					</Row>
				</Container>
				:
				<Container className="accessSearchArea flex-column borderCurve">
					<Row className="accessSearchHeader">
						<Col sm={6} className="dashboardTitle">
							<h3>Monthly Actions</h3>
						</Col>
						<Col sm={6}>
							<VendorSetIDDropdown onChange={updateAudience} colSize={5} onListLoaded={onAudienceReady} currentAudience={currentAudience} showGlobalOption={true} />
						</Col>
					</Row>
					<Row>
						<Col sm={12}>
							<BarChart
								width={1000}
								height={500}
								data={chartData}
								onClick={prepData}
								margin={{
									top: 5,
									right: 30,
									left: 20,
									bottom: 5,
								}}
							>
								<CartesianGrid strokeDasharray="9 9" />
								<XAxis dataKey="title" />
								<YAxis />
								<Tooltip />
								<Legend verticalAlign="top" layout="horizontal" align="left" height={36} />
								{/*<Bar stackId="a"  dataKey="successful_SignIns" fill="#ff7373" />*/}
								{/*<Bar stackId="a"  dataKey="successful_LogOffs" fill="#8884d8" />*/}
								<Bar stackId="a" dataKey="requests_Created" name="Bank Requests Created" fill="#4B4D4F" />
								<Bar stackId="a" dataKey="contacts_Created" name="Contacts Created" fill="#0066F5" />
								<Bar stackId="a" dataKey="reject_Emails_Sent" name="Reject Emails" fill="#F5B700" />
								<Bar stackId="a" dataKey="role_Changes" name="User Role Changes" fill="#82ca9d" />
								<Bar stackId="a" dataKey="supplier_User_Info_Changes" name="User Updates" fill="#ff6666" />
								<Bar stackId="a" dataKey="vendor_Profile_Changes" name="Vndr Profile Updates" fill="#468499" />
								<Bar stackId="a" dataKey="wF_API_Calls" name="WF API Calls" fill="#003366" />
								{/*<Bar stackId="a" dataKey="site_Errors" name="Errors" fill="#ff6666" />*/}
								{/*<Bar stackId="a"  dataKey="supplier_Info_Changes" fill="#ffc658" />*/}
								{/*<Bar stackId="a"  dataKey="supplier_Admin_Info_Changes" fill="#ffc658" />*/}

							</BarChart>
						</Col>
					</Row>
					<Row>
						<Col sm={12}>
							{(currentIndex > -1) ?
								<Popup open={showPopUp} modal closeOnDocumentClick={true} closeOnEscape={true} onClose={closePopUp}>
									{(close) => (
										showAuditData()
									)}
								</Popup>

								: <></>}
						</Col>
					</Row>
				</Container>
		);
}
export const PerMonthLogins = (props) => {
	const [isLoading, setIsLoading] = useState(true);
	const [showPopUp, setShowPopUp] = useState(false);
	const [chartData, setChartData] = useState(null);
	const [currentIndex, setCurrentIndex] = useState(-1);
	const [currentAudience, setCurrentAudience] = useState("GLOBAL");
	const [isAudiencesReady, setIsAudiencesReady] = useState(true);
	useEffect(() => {
		if (isAudiencesReady) {
			getData(currentAudience);
		}
	}, [isAudiencesReady]);

	const getData = async (audience) => {
		//currentAudience
		ServiceCalls.getSiteLogins().then(function (data) {
			if (data) {
				const consolidatedData = data.reduce((acc, obj) => {
					const key = `${obj.year}-${obj.month}`;

					if (!acc[key]) {
						acc[key] = { year: obj.year, month: obj.month, vendors: [] };
					}

					const vendorIndex = acc[key].vendors.findIndex(v => v.vendorSetID === obj.vendorSetID);
					if (vendorIndex === -1) {
						acc[key].vendors.push({ vendorSetID: obj.vendorSetID, loginCount: obj.loginCount });
					} else {
						acc[key].vendors[vendorIndex].loginCount += obj.loginCount;
					}

					return acc;
				}, {});

				const resultArray = Object.values(consolidatedData);
				var years = resultArray.reduce(function (r, a) {
					r[a.year] = r[a.year] || [];
					r[a.year].push(a);
					return r;
				}, Object.create(null));
				setChartData(years);
				setIsLoading(false);
			}
		});
	}
	const prepData = (_data, index) => {
		setCurrentIndex(_data.activeTooltipIndex);
		setShowPopUp(true);
	}
	const closePopUp = () => {
		setShowPopUp(false);
	}


	
	const buildCharts = () => {
		var display = [];
		

		for (const item in chartData) {
			var chartInfo = chartData[item];
			const flattenedData = chartInfo.flatMap(entry =>
				entry.vendors.map(vendor => ({
					year: entry.year,
					month: entry.month,
					vendorSetID: vendor.vendorSetID,
					loginCount: vendor.loginCount
				}))
			);

			const groupedData = flattenedData.reduce((acc, item) => {
				const key = `${item.year}-${item.month}`;
				if (!acc[key]) {
					acc[key] = { date: key };
				}
				acc[key][item.vendorSetID] = item.loginCount;
				return acc;
			}, {});

			const formattedData = Object.values(groupedData);


				display.push(
					<AreaChart
						width={1000}
						height={500}
						data={formattedData}
						margin={{
							top: 5,
							right: 30,
							left: 20,
							bottom: 5,
						}}
					>
						<CartesianGrid strokeDasharray="9 9" />
						<XAxis dataKey="date" />
						<YAxis />
						<Tooltip />
						<Legend verticalAlign="top" layout="horizontal" align="left" height={36} />
						<Area type="monotone" dataKey="UHGID" stackId="1" stroke="#8884d8" fill="#8884d8" />
						<Area type="monotone" dataKey="EMEA" stackId="1" stroke="#0066F5" fill="#0066F5" />
					</AreaChart>);
			}
		

		return display;
	}

	return (
		(isLoading)
			? <Container className="accessSearchArea flex-column borderCurve">
				<Row className="accessSearchHeader">
					<Col sm={6} className="dashboardTitle">
						<h3>Monthly Signins</h3>
					</Col>
					<Col sm={6}>
						&nbsp;
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						<Loading />
					</Col>
				</Row>
			</Container>
			:
			<Container className="accessSearchArea flex-column borderCurve">
				<Row className="accessSearchHeader">
					<Col sm={6} className="dashboardTitle">
						<h3>Monthly Signins</h3>
					</Col>
					<Col sm={6}>
						&nbsp;
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						{ 
							buildCharts()	

                             }
							
					</Col>
				</Row>
				
			</Container>
	);
}


